import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje, MensajeSiNo } from "../../components/mensajes";
import { Dimmer } from "../spinner";
import moment from "moment";
import { formatMoneda, validaMonto, formatoMonto } from "../../util/varios";
import axios from "axios";
import CatalogoAgenteTipo3 from "../../catalogos/catalogoAgenteTipo3";

export const OtrosImpuestos = (props) => {
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const op = require("../../../public/modulos/datos");

  const txtConcepto = useRef();
  const txtTipoIngreso = useRef();
  const txtMina = useRef();
  const txtProduccion = useRef();
  const txtTimbres = useRef();
  const txtGeneral = useRef();
  const txt1x500 = useRef();
  const txtMonto = useRef();
  const txtDireccion = useRef();
  const txtNombre = useRef();
  const txtRif = useRef();
  const txtValorVh = useRef();
  const txtCapCarga = useRef();
  const btnCancela = useRef();
  const btnAcepta = useRef();

  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [catalogo, setCatalogo] = useState(false);
  const [activate, setActivate] = useState(false);
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  const idusuario = JSON.parse(localStorage.getItem("idusuario"));
  const [records, setRecords] = useState([]);
  const [values, setValues] = useState({
    idagente: "",
    nombre: "",
    fecha: fechaSistema,
    direccion: "",
    rif: "",
  });
  const [operacion, setOperacion] = useState(0);
  const [activo, setActivo] = useState(true);
  const [activo2, setActivo2] = useState(true);
  const [activo1, setActivo1] = useState(true);
  const [checkk, setCheckk] = useState(false);
  const [tipo, setTipo] = useState();
  const [tipovalor, setTipovalor] = useState();

  const SeleccionarRegistros = () => {
    setActivate(true);

    let campos = "*";
    let nomtab = "tipoimpuesto";
    let orden = "idtipoimpuesto";

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setRecords(response.data);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const procesarFactura = (body) => {
    let endpoint = `${op.conexion}/api/Caja_Ingreso/crearfactura`;
    setActivate(true);

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        setActivate(false);
        if (response.status == 200) {
          let msg = "Desea Facturar Otros Impuestos al mismo Contribuyente?.";
          setMensajesino({
            mostrar: true,
            titulo: "Confirmación.",
            texto: msg,
            icono: "confirmacion",
          });
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const onChange = (event) => {
    if (
      event.target.name === "direccion" ||
      event.target.name === "rif" ||
      event.target.name === "nombre" ||
      event.target.name === "concepto"
    ) {
      event.target.value = event.target.value.toUpperCase();
      setValues({ ...values, [event.target.name]: event.target.value });
    } else if (event.target.name === "tipoingreso") {
      let tipo = txtTipoIngreso.current.value;
      if (tipo > 0) {
        setActivo2(false);
        setActivo1(false);
        setActivo(true);
        txtConcepto.current.value = "";
        txtMonto.current.value = "";
        txtGeneral.current.checked = true;
        txtTimbres.current.checked = checkk;
        txtMina.current.checked = checkk;
        txtProduccion.current.checked = checkk;
        txt1x500.current.checked = checkk;
      } else {
        setActivo2(true);
        setActivo1(true);
        setActivo(true);
        txtNombre.current.value = "";
        txtRif.current.value = "";
        txtDireccion.current.value = "";
        txtConcepto.current.value = "";
        txtMonto.current.value = "";
        txtGeneral.current.checked = true;
        txtTimbres.current.checked = checkk;
        txtMina.current.checked = checkk;
        txtProduccion.current.checked = checkk;
        txt1x500.current.checked = checkk;
      }
    } else {
      setValues({ ...values, [event.target.name]: event.target.value });
    }
  };

  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (
        event.target.value === "" ||
        parseFloat(
          event.target.value.trim().replace(".", "").replace(",", ".")
        ) === 0.0
      ) {
        event.target.value = "0,00";
      }
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.legth
        );
      }
      if (event.which === 13) {
        if (event.target.id === "credito") {
          txtMonto.current.focus();
        }
      }
      if (event.which === 13) {
        if (event.target.id === "inputvalorvehiculo") {
          txtValorVh.current.focus();
        }
      }
      if (event.which === 13) {
        if (event.target.id === "inputcapacidadcarga") {
          txtCapCarga.current.focus();
        }
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    txtMonto.current.value = "0,00";
    txtConcepto.current.value = "";
    txtTipoIngreso.current.value = "";
  };

  const handleCloseNo = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    txtNombre.current.value = "";
    txtRif.current.value = "";
    txtDireccion.current.value = "";
    txtConcepto.current.value = "";
    txtMonto.current.value = "";
    txtGeneral.current.checked = true;
    txtTimbres.current.checked = checkk;
    txtMina.current.checked = checkk;
    txtProduccion.current.checked = checkk;
    txt1x500.current.checked = checkk;
    props.onHideCancelar();
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;

    if (txtTipoIngreso.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe seleccionar el Tipo de Ingreso",
        icono: "informacion",
      });
      sigue = false;
      txtTipoIngreso.current.value = "";
      txtTipoIngreso.current.focus();
    } else if (txtNombre.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Campo Nombre no debe ir Vacio",
        icono: "informacion",
      });
      sigue = false;
      txtNombre.current.value = "";
      txtNombre.current.focus();
    } else if (txtRif.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Campo Rif no debe ir Vacio",
        icono: "informacion",
      });
      sigue = false;
      txtRif.current.value = "";
      txtRif.current.focus();
    } else if (txtDireccion.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Describa la Dirección",
        icono: "informacion",
      });
      sigue = false;
      txtDireccion.current.value = "";
      txtDireccion.current.focus();
    } else if (
      txtMonto.current.value.trim() === "" ||
      txtMonto.current.value.trim() === "0,00"
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Monto de la Factura no debe ir Vacio o ser Igual a 0",
        icono: "informacion",
      });
      sigue = false;
      txtMonto.current.value = "";
      txtMonto.current.focus();
    } else if (txtConcepto.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe ingresar el Concepto de la Factura",
        icono: "informacion",
      });
      sigue = false;
      txtConcepto.current.value = "";
      txtConcepto.current.focus();
    } else if (sigue) {
      var factu = [];
      var factudet = [];
      var idTipIngre = txtTipoIngreso.current.value;

      factu.push({
        //idcontribuyente: txtAgente.current.value,
        totalinmpuesto: txtMonto.current.value
          .replace(/\./g, "")
          .replace(",", "."),
        totalrecargo: "0.00",
        totalinteres: "0.00",
        idtipoingreso: idTipIngre,
        fechaemision: props.fecha
          ? props.fecha !== null
            ? moment(props.fecha).format("YYYY-MM-DD")
            : moment(fechaSistema).format("YYYY-MM-DD")
          : moment(fechaSistema).format("YYYY-MM-DD"),
        descripcion: txtConcepto.current.value.toUpperCase(),
        tablacontribuyente: "otropago",
        tabladeuda: "otropago",
        status: 0,
        nombrecontri: txtNombre.current.value.toUpperCase(),
        direccioncontri: txtDireccion.current.value.toUpperCase(),
        cedrif: txtRif.current.value.toUpperCase(),
        totalmulta: "0.00",
        deducible: "0.00",
        facturador: idusuario,
        totalfactura: txtMonto.current.value
          .replace(/\./g, "")
          .replace(",", "."),
      });

      factudet.push({
        montoimpuesto: txtMonto.current.value
          .replace(/\./g, "")
          .replace(",", "."),
        montorecargo: "0.00",
        montointeres: "0.00",
        montomulta: "0.00",
        montodescuento: "0.00",
        periodo: props.fecha
          ? props.fecha !== null
            ? moment(props.fecha).format("MM-YYYY")
            : moment(fechaSistema).format("MM-YYYY")
          : moment(fechaSistema).format("MM-YYYY"),
      });

      let body = {
        idagen: parseInt(0),
        factu: JSON.stringify(factu),
        factudet: JSON.stringify(factudet),
      };

      procesarFactura(body);
    }
  };

  const blanquear = () => {
    setActivo(true);
    setActivo1(true);
    setActivo2(true);
  };

  const cancelar = (e) => {
    e.preventDefault();
    props.onHideCancelar();
    blanquear();
  };

  const handleCatalogo = () => {
    if (!catalogo) {
      setCatalogo(true);
    } else {
      setCatalogo(false);
    }
  };

  const onHideAceptaCatAge = (id, nom, rif, direccion, status) => {
    setCatalogo(false);

    if (tipo === "expendedor") {
      if (status === "51") {
        txtNombre.current.value = nom;
        txtRif.current.value = rif;
        txtDireccion.current.value = direccion;
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "AGENTE INACTIVO, CONTACTE CON EL ADMINISTRADOR",
          icono: "error",
        });
        txtNombre.current.value = "";
        txtRif.current.value = "";
        txtDireccion.current.value = "";
        txtTipoIngreso.current.value = "";
        txtConcepto.current.value = "";
        txtMonto.current.value = "";
        txtGeneral.current.checked = true;
        txtTimbres.current.checked = checkk;
        txtMina.current.checked = checkk;
        txtProduccion.current.checked = checkk;
        txt1x500.current.checked = checkk;
        blanquear();
      }
    } else if (tipo === "mina") {
      if (status === "51") {
        txtNombre.current.value = nom;
        txtRif.current.value = rif;
        txtDireccion.current.value = direccion;
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "AGENTE INACTIVO, CONTACTE CON EL ADMINISTRADOR",
          icono: "error",
        });
        txtNombre.current.value = "";
        txtRif.current.value = "";
        txtDireccion.current.value = "";
        txtTipoIngreso.current.value = "";
        txtConcepto.current.value = "";
        txtMonto.current.value = "";
        txtGeneral.current.checked = true;
        txtTimbres.current.checked = checkk;
        txtMina.current.checked = checkk;
        txtProduccion.current.checked = checkk;
        txt1x500.current.checked = checkk;
        blanquear();
      }
    } else if (tipo === "produccion") {
      if (status === "51") {
        txtNombre.current.value = nom;
        txtRif.current.value = rif;
        txtDireccion.current.value = direccion;
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "AGENTE INACTIVO, CONTACTE CON EL ADMINISTRADOR",
          icono: "error",
        });
        txtNombre.current.value = "";
        txtRif.current.value = "";
        txtDireccion.current.value = "";
        txtTipoIngreso.current.value = "";
        txtConcepto.current.value = "";
        txtMonto.current.value = "";
        txtGeneral.current.checked = true;
        txtTimbres.current.checked = checkk;
        txtMina.current.checked = checkk;
        txtProduccion.current.checked = checkk;
        txt1x500.current.checked = checkk;
        blanquear();
      }
    } else if (tipo === "impuesto1x500") {
      if (status === "51") {
        txtNombre.current.value = nom;
        txtRif.current.value = rif;
        txtDireccion.current.value = direccion;
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "AGENTE INACTIVO, CONTACTE CON EL ADMINISTRADOR",
          icono: "error",
        });
        txtNombre.current.value = "";
        txtRif.current.value = "";
        txtDireccion.current.value = "";
        txtTipoIngreso.current.value = "";
        txtConcepto.current.value = "";
        txtMonto.current.value = "";
        txtGeneral.current.checked = true;
        txtTimbres.current.checked = checkk;
        txtMina.current.checked = checkk;
        txtProduccion.current.checked = checkk;
        txt1x500.current.checked = checkk;
        blanquear();
      }
    }
  };

  const cerrarModal = () => {
    props.onHideRenderizar();
    props.onHideCancelar();
    blanquear();
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const onCheck = () => {
    if (txtTimbres.current.checked) {
      setTipo("expendedor");
      setTipovalor(true);
      txtNombre.current.value = "";
      txtRif.current.value = "";
      txtDireccion.current.value = "";
      txtConcepto.current.value = "";
      txtMonto.current.value = "";
    } else if (txtMina.current.checked) {
      setTipo("mina");
      setTipovalor(true);
      txtNombre.current.value = "";
      txtRif.current.value = "";
      txtDireccion.current.value = "";
      txtConcepto.current.value = "";
      txtMonto.current.value = "";
    } else if (txtProduccion.current.checked) {
      setTipo("produccion");
      setTipovalor(true);
      txtNombre.current.value = "";
      txtRif.current.value = "";
      txtDireccion.current.value = "";
      txtConcepto.current.value = "";
      txtMonto.current.value = "";
    } else if (txt1x500.current.checked) {
      setTipo("impuesto1x500");
      setTipovalor(true);
      txtNombre.current.value = "";
      txtRif.current.value = "";
      txtDireccion.current.value = "";
      txtConcepto.current.value = "";
      txtMonto.current.value = "";
    } else if (txtGeneral.current.checked) {
      txtNombre.current.value = "";
      txtRif.current.value = "";
      txtDireccion.current.value = "";
      txtConcepto.current.value = "";
      txtMonto.current.value = "";
    }

    if (
      txtTimbres.current.checked ||
      txtMina.current.checked ||
      txtProduccion.current.checked ||
      txt1x500.current.checked
    ) {
      setActivo(false);
      setActivo2(true);
    } else {
      setActivo(true);
      setActivo2(false);
    }
  };

  useEffect(() => {
    SeleccionarRegistros();
  }, []);

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        btnAcepta.current.focus();
        setOperacion(props.operacion);
      }}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <div className="fw-bold text-light">
          <h3>{props.tipo}</h3>
        </div>
        <button
          ref={btnCancela}
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#FFF", color: "" }}>
        <CatalogoAgenteTipo3
          show={catalogo}
          tipo={tipo}
          valor={tipovalor}
          onHideCancelaCatAge={handleCatalogo}
          onHideAceptaCatAge={onHideAceptaCatAge}
        />

        <Mensaje
          mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === "Exito."
              ? cerrarModal()
              : setMensaje({
                  mostrar: false,
                  titulo: "",
                  texto: "",
                  icono: "",
                });
          }}
        />
        <MensajeSiNo
          mensaje={mensajesino}
          onHideNo={handleCloseNo}
          onHideSi={handleCloseSi}
        />
        <Dimmer active={activate} />
        <div
          className="titulos"
          style={{
            height: "auto",
            minHeight: "auto",
            maxHeight: "90vh",
            overflow: "auto",
          }}
        >
          <div className="container">
            <fieldset className="row border-azul rounded mx-auto">
              <legend className="float-none m-0 w-auto">
                Datos de la Factura
              </legend>
              <div className="col-md-12 py-2 row m-0">
                <div className="col-sm-9 col-12 px-1">
                  <div className="input-group input-group-sm">
                    <span
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Tipo de Ingreso:
                    </span>
                    <select
                      className="custom-select text-center"
                      ref={txtTipoIngreso}
                      name="tipoingreso"
                      id="inputCedula"
                      onChange={onChange}
                    >
                      <option value="">
                        --Seleccione el Tipo de Ingreso--
                      </option>
                      {records &&
                        records.map((item, index) => (
                          <option key={index} value={item.idtipoingreso}>
                            {" "}
                            {item.descripcion}{" "}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>

                <div className="col-sm-3 col-12 px-1">
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Fecha:
                    </label>
                    <input
                      type="date"
                      disabled={activo1}
                      className="form-control"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      name="fecha"
                      defaultValue={
                        props.fecha
                          ? props.fecha !== null
                            ? moment(props.fecha).format("YYYY-MM-DD")
                            : ""
                          : moment(fechaSistema).format("YYYY-MM-DD")
                      }
                      onChange={onChange}
                      id="inputFechaInscripcion"
                    />
                  </div>
                </div>
              </div>

              <fieldset className="row border-azul col-md-9 rounded mx-auto">
                <legend className="float-none m-0 w-auto">
                  Tipo de Contribuyente
                </legend>
                <div className="col-md-12 row m-0 py-1">
                  <div className="col-sm-2 ml-auto">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        disabled={activo1}
                        ref={txtGeneral}
                        type="radio"
                        name="exampleRadios"
                        defaultChecked={checkk}
                        id="exampleRadios7"
                        onChangeCapture={onCheck}
                      />
                      <label className="form-check-label" for="exampleRadios7">
                        General
                      </label>
                    </div>
                  </div>

                  <div className="col-sm-2 ml-auto">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        disabled={activo1}
                        ref={txtTimbres}
                        type="radio"
                        name="exampleRadios"
                        id="exampleRadios1"
                        onChangeCapture={onCheck}
                      />
                      <label className="form-check-label" for="exampleRadios1">
                        Timbres
                      </label>
                    </div>
                  </div>
                  <div className="col-sm-2 ml-auto">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        disabled={activo1}
                        ref={txtMina}
                        type="radio"
                        name="exampleRadios"
                        id="exampleRadios2"
                        onChangeCapture={onCheck}
                      />
                      <label className="form-check-label" for="exampleRadios2">
                        Minas
                      </label>
                    </div>
                  </div>
                  <div className="col-sm-2 ml-auto">
                    <div className="form-check px-2">
                      <input
                        className="form-check-input"
                        disabled={activo1}
                        ref={txtProduccion}
                        type="radio"
                        name="exampleRadios"
                        id="exampleRadios3"
                        onChangeCapture={onCheck}
                      />
                      <label className="form-check-label" for="exampleRadios3">
                        Producción
                      </label>
                    </div>
                  </div>
                  <div className="col-sm-2 ml-auto">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        disabled={activo1}
                        ref={txt1x500}
                        type="radio"
                        name="exampleRadios"
                        id="exampleRadios4"
                        onChangeCapture={onCheck}
                      />
                      <label className="form-check-label" for="exampleRadios4">
                        1x1000
                      </label>
                    </div>
                  </div>
                </div>
              </fieldset>

              <div className="col-md-12 py-1"></div>

              <fieldset className="row border-azul rounded mx-auto">
                <legend className="float-none m-0 w-auto">
                  Datos del Contribuyente
                </legend>
                <div className="col-md-12 py-2 row m-0">
                  <div className="col-sm-8 col-12">
                    <div className="input-group input-group-sm">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Nombre del Contribuyente:
                      </label>
                      <input
                        type="text"
                        disabled={activo2}
                        ref={txtNombre}
                        name="nombre"
                        className="form-control bg-light"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        onChange={onChange}
                      />
                    </div>
                  </div>
                  <div className="col-sm-4 col-12">
                    <div className="input-group input-group-sm">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Cédula o RIF:
                      </label>
                      <input
                        type="text"
                        disabled={activo2}
                        ref={txtRif}
                        name="rif"
                        className="form-control bg-light"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        onChange={onChange}
                      />
                      <button
                        className="btn btn-info"
                        disabled={activo}
                        onClick={handleCatalogo}
                      >
                        <i className="fa fa-search"></i>
                      </button>
                    </div>
                  </div>
                  <div className="col-sm-12 col-12 py-1">
                    <div className="input-group input-group-sm">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Dirección:
                      </label>
                      <input
                        type="text"
                        disabled={activo2}
                        ref={txtDireccion}
                        name="direccion"
                        className="form-control bg-light"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        onChange={onChange}
                      />
                    </div>
                  </div>
                </div>
              </fieldset>

              <div className="col-md-12 py-2 row m-0">
                <div className="col-sm-5 col-12 py-1 ml-auto px-1">
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Monto Total a Facturar:
                    </label>
                    <input
                      type="text"
                      disabled={activo1}
                      autoComplete="off"
                      className="form-control text-right"
                      ref={txtMonto}
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      defaultValue={
                        values && values.monto
                          ? formatMoneda(
                              values.monto
                                .toString()
                                .replace(",", "")
                                .replace(".", ","),
                              ",",
                              ".",
                              2
                            )
                          : ""
                      }
                      onBlur={handleInputMontoChange}
                      onKeyUp={handleInputMontoChange}
                      placeholder="0,00"
                    />
                  </div>
                </div>

                <div className="col-sm-12 col-12 px-1">
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Concepto:
                    </label>
                    <textarea
                      type="text"
                      disabled={activo1}
                      autoComplete="off"
                      className="form-control h-25"
                      name="concepto"
                      ref={txtConcepto}
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      onChange={onChange}
                    />
                  </div>
                </div>
              </div>
            </fieldset>
            <div className="col-md-12 py-1"></div>

            <div className="col-sm-12 py-1 d-flex justify-content-end  align-items-center">
              <button
                ref={btnAcepta}
                disabled={operacion === 4 ? true : false}
                onClick={onChangeValidar}
                className="btn btn-sm rounded-pill btn-success col-md-2"
              >
                <i className="fas fa-check-circle"> Aceptar</i>
              </button>
              <button
                ref={btnCancela}
                onClick={cancelar}
                className="btn btn-danger btn-sm rounded-pill col-md-2"
              >
                <i className="fas fa-window-close"> Cancelar</i>
              </button>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/ingresos/modalOtroPago.js